import React from "react";
import styled from 'styled-components'
import { useFormContext } from './FormContext'

const Stage3SelectedItems = ({selectedItems:items,setSelectedItems,zone}) => {

    //format of selectedItems is : id,code,breadcrumb

     const { formData, updateFormData } = useFormContext();

     //console.log(formData)

    // Function to remove an item by id
    const handleRemove = (id) => {
        if(zone.zoneId == 1){
            setSelectedItems((prevSelectedItems)=> {
                const updatedItems = prevSelectedItems.filter((item) => item.id !== id);
                updateFormData('stage3',{
                    ...formData.stage3,
                    products:updatedItems
                  })
                return updatedItems;
              })
        }else if(zone.zoneId == 2){
            setSelectedItems((prevSelectedItems)=> {
                const updatedItems = prevSelectedItems.filter((item) => item.id !== id);
                updateFormData('stage3',{
                    ...formData.stage3,
                    geography:updatedItems
                  })
                return updatedItems;
              })
        }
      
    };

    const handleRemoveAll = async () => {
        if(zone.zoneId == 1){
            setSelectedItems((prevSelectedItems)=> {
                const updatedItems = [];
                updateFormData('stage3',{
                    ...formData.stage3,
                    products:updatedItems
                  })
                return updatedItems;
              })
        }else if(zone.zoneId == 2){
            setSelectedItems((prevSelectedItems)=> {
                const updatedItems = [];
                updateFormData('stage3',{
                    ...formData.stage3,
                    geography:updatedItems
                  })
                return updatedItems;
              })
        }
        else{
            // handle for other zones here
        }
    }

    return (
        <ListContainer>
            <ul className="item-list">
                {
                    items?.length > 0 ?  <li key="removeitem">    <p>Remove All</p>  
                          <p className="delete-button" onClick={handleRemoveAll}><iconify-icon icon="typcn:delete-outline"></iconify-icon></p> </li> : <></>
                }
                { 
                // data.level3?.filter(elem => elem.)
                items?.map((item) => (
                    <>
                        <li key={item.id}>
                          <p> {item.breadcrumb}</p>  
                          <p className="delete-button" onClick={() => handleRemove(item.id)}><iconify-icon icon="typcn:delete-outline"></iconify-icon></p>
                         </li>
                    </>
                ))}
            </ul>
        </ListContainer>
    );
};

export default Stage3SelectedItems;

const ListContainer = styled.div`
.item-list{
    list-style-type:none;
    padding-left:10px;
    padding-right:10px;
    height:var(--stage3-data-panel-height);
    overflow-y:scroll;
    font-size:14px;
    
    li{
        display:flex;
        justify-content:space-between;
        padding-top:7px;
        padding-bottom:5px;
        border-bottom: 1px dashed #B9B9B9;
        font-weight: 300;
        p{
            margin:0px !important;
        }
        p.delete-button{
            color:#AC1424;
            font-size: 18px;
        }
    }
}
`